export function timestampToDateFormat(phpTimestamp: number) {
  let d = new Date(phpTimestamp);
  return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDay().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}: ${d.getMinutes().toString().padStart(2, '0')}`;
}
